import { AdjustedLine, ModifierContext } from "../../modifier-models";
import { BaseRule } from "../../rule-base";

export class RulePhysio0001 extends BaseRule {
    name = 'Physio 0001: Appointment not kept - No charge';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.code !== '0001') return;

        if (autoApply) {
            // Fee may be charged but is not payable by medical schemes
            // Each case considered on merit - no automatic reduction
            line.trace.push('Physio 0001: Appointment not kept - Fee may be charged but not payable by schemes');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0001',
                message: 'Appointment not kept - Fee may be charged but is not payable by medical schemes. Each case considered on merit.',
                kind: 'overwrite',
                unitsDelta: line.adjustedUnits
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        lines.forEach(line => {
            if (line.code === '0001') {
                // Fee may be charged but is not payable by medical schemes
                line.trace.push('Physio 0001: Appointment not kept - Fee may be charged but not payable by schemes');
            }
        });
        return lines;
    }
} 